<template lang="pug">
el-table(:data="eventLogs" cell-class-name="el-table-cell" row-class-name="event-table-row" header-row-class-name="el-table-header" v-loading="isLoading")
  div.empty(slot="empty")
    img(:src="images.empty")
    p {{ $t('Dashboard.none_data') }}
  el-table-column(prop="name" :label="$t('Dashboard.table-cell04')" width="130")
  el-table-column(:label="$t('Dashboard.table-cell05')")
    template(slot-scope="props")
      el-tag(size="mini") {{ showActions(props.row.action_type) }}
  el-table-column(:label="$t('Dashboard.table-cell02')" width="137" align="center")
    template(slot-scope="props")
      span.count {{ props.row.oneday_access.toLocaleString() }}
      span.percent(:class="checkUpdown(props.row.beforeday_access,props.row.oneday_access)")
        i(:class="checkUpdownIcon(props.row.beforeday_access,props.row.oneday_access)")
        | {{ checkPercentage(props.row.beforeday_access,props.row.oneday_access) }}
  el-table-column(:label="$t('Dashboard.table-cell06')" width="80" align="right")
    template(slot-scope="props")
      span {{ props.row.total.toLocaleString() }}
</template>

<script>
import actions from '@/utils/defines/actions.js'
export default {
  mixins: [actions],
  data () {
    return {
      isLoading: true,
      images:{
        empty: require('@/assets/empty_event.svg')
      }
    }
  },
  computed: {

    eventLogs () {
      return this.$store.state.log.eventLogs.one_day_counts
    }
  },
  methods: {
    //表示するアクション
    showActions: function(type){
      for(var i=0; i<this.actions.length; i++){
        if (this.actions[i].type == type){
          return this.$t(this.actions[i].name);
        }
      }
    },

    //上中下判定
    checkUpdown: function(before, after)
    {
      if (before == after) return "equal"
      return before < after ? "up" : "down"
    },

    //アイコンの上中下
    checkUpdownIcon: function(before, after)
    {
      if (before == after) return "el-icon-caret-right"
      return before < after ? "el-icon-caret-top" : "el-icon-caret-bottom"
    },

    //パーセンテージ算出
    checkPercentage: function(before, after)
    {
      if (before == after) return "0%"
      return Math.ceil(((after/before)-1)*100).toLocaleString() + "%"
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.el-table ::v-deep {
  .el-table-header th {
    padding: 0 0 3px 0;
    font-size: 11px;
    font-weight: normal;
    color: #999;
  }

  .event-table-row td {
    padding: 8px 0;
    font-size: 13px;
  }
}

.empty {
  margin: 40px 0;
  img { width: 100px; }
  p { font-size: 12px; }
}

.count {
  display: inline-block;
  width: 62px;
  text-align: right;
}
.percent {
  display: inline-block;
  width: 50px;
  font-size: 11px;
  margin-left: 3px;
  text-align: left;
}

.up {
  color: $safe;
}
.equal {
  color: #5baf31;
}
.down {
  color: $danger;
}

</style>
